import React, {useContext, useEffect, useState} from 'react';
import {Alert, Button, Form, Input, Select, TreeSelect} from "antd";
import {CarryOutOutlined, LoadingOutlined, SendOutlined} from "@ant-design/icons";
//import {CKEditor} from "@ckeditor/ckeditor5-react"
//import StatementOfSuitabilityParagraphEditor from "ckeditor5-custom-build";
import {API} from "aws-amplify";
import {capitaliseWords} from "../../../assets/scripts/string-functions";
import {getUserDocumentKey} from "../../providers/mortgage/useMortgageDocumentsService";
import {LONGDATE, SYSTEMIDENTITYID} from "../../../assets/scripts/constants";
import dayjs from "dayjs";
import {getUserUploadKey} from "../../providers/mortgage/useMortgageUploadService";
import {ContactMethods} from "../../../models";
import useBackendUsers from "../../providers/mortgage/useBackendUsers";
import {postProcessEmail} from "../../providers/mortgages-messaging/emails/_emailHelpers";
//import CKEditor from "../_new/ck-editor/CKEditor";
import MyEditor from "../_new/ck-editor/MyEditor";
import {Lenders} from "../../providers/LendersProvider";

const {SHOW_PARENT} = TreeSelect;
const otherEmailSources = {
    SALARY_CERT: {
        title: 'Salary Certificate',
        source: `private/${SYSTEMIDENTITYID}/emailable-files/salary-certificate.pdf`,
        name: 'salary-certificate.pdf'
    }, ROYAL_LONDON_MPI_BROCHURE: {
        title: 'Royal London Mortgage Protection Brochure',
        source: `private/${SYSTEMIDENTITYID}/emailable-files/royal-london-mortgage-protection-brochure.pdf`,
        name: 'royal-london-mortgage-protection-brochure.pdf'
    }, ZURICH_MPI_BROCHURE: {
        title: 'Zurich Mortgage Protection Brochure',
        source: `private/${SYSTEMIDENTITYID}/emailable-files/zurich-mortgage-protection-brochure.pdf`,
        name: 'zurich-mortgage-protection-brochure.pdf'
    },

}
const useMegaValueInTree = true
function ComposeEmail({
                          close, config, defaultFromAccount, chatGptChoices
                      }) {
    const [megaAttachmentIds, setMegaAttachmentIds] = useState([]); // policy document ids
    //const [documentIds, setDocumentIds] = useState(config.attachmentIds || []); // document ids
    //const [uploadIds, setUploadIds] = useState(config.uploadIds || []); // attachment ids
    const [sent, setSent] = useState(false)
    const {lenders}  = useContext(Lenders)
    const [form] = Form.useForm()
    const helpAccount = {
        label: 'Help', value: 'help', email: 'help@sussd.ie'
    }
    const kevinAccount = {
        label: 'Kevin', value: 'kevin', email: 'kevin@sussd.ie'
    }
    const grainneAccount = {
        label: 'Grainne', value: 'grainne', email: 'grainne@sussd.ie'
    }
    const stephenAccount = {
        label: 'Stephen', value: 'stephen', email: 'stephen@sussd.ie'
    }
    const allowedAccounts = [helpAccount, kevinAccount, grainneAccount, stephenAccount
        // {
        //     label: me.firstName,
        //     value: me.mailAccount,
        //     email: me.email
        // }
    ]
    // const handleMegaAttachmentChange = (values) => {
    //     console.log({values})
    //     const docIds = values.filter(v => v.startsWith('CustomerDocument:')).map(v => v.replace('CustomerDocument:', ''))
    //     const uploadIds = values.filter(v => v.startsWith('CustomerUpload:')).map(v => v.replace('CustomerUpload:', ''))
    //     const policyIds = values.filter(v => v.startsWith('FixedDocument:')).map(v => v.replace('FixedDocument:', ''))
    //     setDocumentIds(docIds)
    //     setUploadIds(uploadIds)
    //     setPolicyIds(policyIds)
    // }
    const emailChangedRef = React.useRef(null)
    const {me} = useBackendUsers()
    const [state, setState] = useState({
        body: '',
        sending: false,
        reply: config.reply,
        fromAccountOptions: []
    })

    const switchToCompose = () => {
        setState(s => ({
            ...s, reply: null
        }))
        emailChangedRef.current = null
    }
    const getAllowedReplySenders = (email)=>{
        let options = []
        if (email){
            for (let recipientAddress of email.to) {
                const found = allowedAccounts.find(it => it.email === recipientAddress)
                if (found) {
                    options.push(found)
                }
            }
            for (let recipientAddress of email.cc) {
                const found = allowedAccounts.find(it => it.email === recipientAddress)
                if (found) {
                    options.push(found)
                }
            }
        }

        return options
    }
    //Mustafa  app ID 35615bad-2d76-4d4f-b25e-2fc06d77fc84
    // Incorrect ID 29c1b078-cc13-40f1-9ad9-1dcc61183c0b
    const getFromAccountOptions = (emailIfReply) => {
        let options = []
        const me = defaultFromAccount
        console.log({defaultFromAccount})
        if (!!emailIfReply) {

            // a reply can only have 1 sender - the recipient of the email

            const email = emailIfReply
            options.push(...getAllowedReplySenders(emailIfReply))
            console.log({options})
            if (!options.find(it => it.value === defaultFromAccount.mailAccount)) {
                options.push({
                    label: me.firstName,
                    value: me.mailAccount,
                    email: me.email
                })
            }
        } else {
            // a new email can be sent from any account
            options = [helpAccount, kevinAccount, grainneAccount, //stephenAccount
                // {
                //     label: me.firstName,
                //     value: me.mailAccount,
                //     email: me.email
                // }, helpAccount
            ]
        }

        return options
    }

    console.log({allowedSenders: getAllowedReplySenders(state.reply)})
    const handleFormFinish = async (e) => {

        const valid = await form.validateFields()
        setState((s => ({
            ...s, sending: true
        })))
        const mailConfig = {
            body: postProcessEmail(state.body),
            to: valid.to,
            cc: valid.cc || [],
            bcc: valid.bcc || [],
            account: valid.from,
            subject: valid.subject,
            attachments: [],
        }
        if (config.mortgage) {
            mailConfig.userapplicantID = config.mortgage.applicant1ID
        }
        if (state.reply) {
            let senders = getAllowedReplySenders(state.reply)
            if (!senders.find(s=>s.value === valid.from)) {
                mailConfig.originalRecipientForReply = senders[0].value
            }
        }

        // START OF NEW METHOD OF ATTACHING FILES
        if (config.mortgage && megaAttachmentIds?.length){
            const fixedDocuments = megaAttachmentIds.filter(id => id.startsWith('FixedDocument:')).map(id => id.replace('FixedDocument:', ''))
            const documentAttachments = megaAttachmentIds.filter(id => id.startsWith('CustomerDocument:')).map(id => id.replace('CustomerDocument:', ''))
            const uploadAttachments = megaAttachmentIds.filter(id => id.startsWith('CustomerUpload:')).map(id => id.replace('CustomerUpload:', ''))
            const lenderDocuments = megaAttachmentIds.filter(id => id.startsWith('LenderDocument:')).map(id => id.replace('LenderDocument:', ''))
            let possibleHardCodedAttachments = Object.keys(otherEmailSources)
            fixedDocuments.forEach(id => {
                if (possibleHardCodedAttachments.includes(id)) {
                    mailConfig.attachments.push( {
                        source: otherEmailSources[id].source, name: otherEmailSources[id].name
                    })
                }
            })
            documentAttachments.forEach(id => {
                const doc = config.mortgage.UserMortgageDocuments.find(it => it.id === id)
                if (doc) {
                    const path = getUserDocumentKey(doc)
                    mailConfig.attachments.push( {
                        source: `private/${doc.identityID}/${path}`, name: doc.fileName
                    })
                }
            })
            uploadAttachments.forEach(id => {
                const upl = config.mortgage.uploads.find(it => it.id === id)
                if (upl) {
                    const path = getUserUploadKey(upl)

                    mailConfig.attachments.push( {
                        source: `private/${upl.identityID}/${path}`, name: upl.fileName + '.' + upl.fileExtension
                    })
                }
            })
            lenderDocuments.forEach(id => {
                lenders.forEach(lender => {
                    if (lender.overlayTemplates){
                        const doc = lender.overlayTemplates.find(it => it.id === id)
                        if (doc) {
                            mailConfig.attachments.push( {
                                source: `private/${SYSTEMIDENTITYID}/${doc.bucketKey}`, name: doc.fileName
                            })
                        }
                    }
                })

            })
        }
        // if (!!config.mortgage && !!valid.documentAttachments) {
        //     let possibleHardCodedAttachments = Object.keys(otherEmailSources)
        //     mailConfig.attachments = valid.documentAttachments.map(id => {
        //         if (possibleHardCodedAttachments.includes(id)) {
        //             return {
        //                 source: otherEmailSources[id].source, name: otherEmailSources[id].name
        //             }
        //         } else {
        //             const doc = config.mortgage.UserMortgageDocuments.find(it => it.id === id)
        //             if (doc) {
        //                 const path = getUserDocumentKey(doc)
        //                 return {
        //                     source: `private/${doc.identityID}/${path}`, name: doc.fileName
        //                 }
        //             }
        //         }
        //
        //     })
        // }
        // if (!!config.mortgage && !!valid.uploadAttachments) {
        //     (valid.uploadAttachments || []).forEach(id => {
        //         const upl = config.mortgage.uploads.find(it => it.id === id)
        //         if (upl) {
        //             const path = getUserUploadKey(upl)
        //
        //             mailConfig.attachments.push({
        //                 source: `private/${upl.identityID}/${path}`, name: upl.fileName + '.' + upl.fileExtension
        //             })
        //         }
        //     })
        // }

        if (state.reply) {
            mailConfig.message_id = state.reply.messageId
        }
        let actuallySent = false
        if (window.location.protocol === 'http:') {
            await new Promise((resolve, reject) => {
                setTimeout(() => {
                    console.log('Simulating email send in dev mode', {mailConfig})

                    actuallySent = true
                    resolve()
                }, 2000)
            })
        } else {
            const mailResult = await API.post("sussdAdminAPI", "/exchange/send/none", {
                body: mailConfig
            })
            if (!mailResult.sent) {
                alert('Email failed to send - reopen from same button as last time')
            } else {
                actuallySent = true
            }
        }

        // await the sending of the email

        setState((s => ({
            ...s, sending: false
        })))
        if (actuallySent) {
            setSent(true)
        }

        close()
    }

    const setBody = (str) => {
        setState(s => ({
            ...s, body: str
        }))
    }
    const submissionID = config?.mortgage?.activeSubmission?.id
    const submissionFilter = item => {
        if (submissionID) {
            return item?.submissionID === submissionID
        }
        return false
    }
    const docsExcludingOldSubmission = config?.mortgage ? config?.mortgage?.UserMortgageDocuments?.filter(submissionFilter) : []
    const uniqueDocumentFolders = [...new Set(docsExcludingOldSubmission.map(item => item.folder))];
    const folderToTitle = (name) => {
        return capitaliseWords(name.split('-').join(' '))
    }
    const treeDataDocuments = uniqueDocumentFolders.map(folder => ({
        value: folder,
        title: folderToTitle(folder),
        icon: <CarryOutOutlined/>,
        selectable:false,
        children: docsExcludingOldSubmission.filter(item => item.folder === folder).map(item => ({
            value: `CustomerDocument:${item.id}`,
            title: item.title + (item.versionNo ? ` v${item.versionNo}` : ''), //   fileName: item.fileName,
            icon: <CarryOutOutlined/>,
            isLeaf: true
        }))
    }))
    const uploadSections = config?.mortgage?.uploadSections
    const stages = uploadSections ? [...new Set(uploadSections.map(s => s.stage))] : []
    const treeDataUploads = stages.map(key => {
        //const sections = stages[key]
        const sections = uploadSections.filter(it => it.stage === key).filter(s => s.isActive)
        return {
            key,
            value: key,
            title: key,
            selectable:false,
            icon: <CarryOutOutlined/>,
            children: sections.map(section => {
                let uploadsInSection = section.uploads.filter(upload => upload.isActive)
                if (!uploadsInSection.length) {
                    return null
                }
                return {
                    key: section.name + section?.index,
                    value: section.name + section?.index,
                    title: section.title, //   fileName: item.fileName,
                    selectable:false,
                    icon: <CarryOutOutlined/>,
                    children: section.uploads.map(upload => {
                        return {
                            //value: upload.id,
                            value: `CustomerUpload:${upload.id}`,
                            title: <div className="d-row">
                                <div style={{width: 90}}>{dayjs(upload.props.upload.createdAt).format(LONGDATE)}</div>
                                <div>{upload.props.upload.fileName}.{upload.props.upload.fileExtension}</div>
                            </div>, //   fileName:
                            isLeaf: true,
                            icon: <CarryOutOutlined/>,
                        }
                    })
                }
            }).filter(it => !!it)
        }
    })

    const megaAttachments = [{
        value:'Lender Documents',
        key: 'Lender Documents',
        title: 'Lender Documents',
        selectable:false,
        icon: <CarryOutOutlined/>,
        children: lenders.map(lender => {
            return {
                value: `lender-Document:${lender.id}`,
                title: lender.lender,
                selectable:false,
                icon: <CarryOutOutlined/>,
                children: lender.overlayTemplates.filter(it=>it.defaultFolder==="policy-documents").sort((a,b)=>{
                    // sort by desc createdAt
                    const aD = dayjs(a.createdAt)
                    const bD = dayjs(b.createdAt)
                    if (aD.isBefore(bD)){
                        return 1
                    }
                    if (aD.isAfter(bD)){
                        return -1
                    }
                    return 0

                }).map(doc => ({
                    value: `LenderDocument:${doc.id}`,
                    title: <div className="d-row">
                        <div style={{width: 90}}>{dayjs(doc.createdAt).format(LONGDATE)}</div>
                        <div>{doc.fileName}</div>
                    </div>, //   fileName:
                    isLeaf: true,
                    icon: <CarryOutOutlined/>,
                 }))
            }
        })
    }, {
        value:'Customer Documents',
        key: 'Customer Documents',
        title: 'Customer Documents',
        selectable:false,
        icon: <CarryOutOutlined/>,
        children: treeDataDocuments
    }, {
        value:'Customer Uploads',
        key: 'Customer Uploads',
        title: 'Customer Uploads',
        selectable:false,
        icon: <CarryOutOutlined/>,
        children: treeDataUploads
    }, {
            value: 'Other Documents',
            title: 'Other Documents',
            icon: <CarryOutOutlined/>,
            disableCheckbox: true,
            children: Object.keys(otherEmailSources).map(key => ({
                value: `FixedDocument:${key}`,
                title: otherEmailSources[key].title,
                icon: <CarryOutOutlined/>,
                isLeaf: true
            }))
    }]

    //const stages = config?.mortgage?.mortgageUploads || {}


    useEffect(() => {
        if (!!sent) {
            if (config.onSent) {
                config.onSent()
            }
            setSent(false)
        }
    }, [sent]);

    useEffect(() => {
        let testerString = JSON.stringify({
            to: config.to, subject: config.subject, reply: config.reply, chatGptChoices
        })
        if (emailChangedRef.current !== testerString) {

            emailChangedRef.current = testerString
            form.setFieldValue('from', config.from || defaultFromAccount || me.mailAccount)
            form.setFieldValue('to', config.to)
            form.setFieldValue('subject', config.subject)
            form.setFieldValue('cc', config.cc)
            const megaAttachmentIds = [];
            (config.attachmentIds || []).forEach(id => {
                megaAttachmentIds.push(`CustomerDocument:${id}`)
            });
            (config.uploadIds || []).forEach(id => {
                megaAttachmentIds.push(`CustomerUpload:${id}`)
            });
            (config.lenderDocumentIds || []).forEach(id => {
                megaAttachmentIds.push(`LenderDocument:${id}`)
            });
            (config.fixedDocumentIds || []).forEach(id => {
                megaAttachmentIds.push(`FixedDocument:${id}`)
            });

            form.setFieldValue('megaAttachments', megaAttachmentIds)
            setMegaAttachmentIds(megaAttachmentIds)
            // form.setFieldValue('documentAttachments', config.attachmentIds || [])
            // form.setFieldValue('uploadAttachments', config.uploadIds || [])
            let body = config?.body ? config.body.replace(/\n/g, '') : ''
            if (chatGptChoices) {
                let firstChatGptChoice = chatGptChoices ? chatGptChoices[0].message.content : []
                // split by new line and wrap items in <p>
                body = chatGptChoices.map(it => `<p>${it.message}</p>`).join('')
            }

            setState(s => ({
                ...s, reply: config.reply, body,
            }))
            setSent(false)
            // setDocumentIds(config.attachmentIds || [])
            // setUploadIds(config.uploadIds || [])
        }
    }, [config.to, config.subject, config.reply]);

    useEffect(() => {

        if (state.reply) {
            const options = getFromAccountOptions(state.reply)
            if (options.length > 0) {
                form.setFieldValue('from', options[0].value)
            }
        }
    }, [state.reply]);

    const key = JSON.stringify({t: config.to, s: config.subject, r: config.reply})
    const fromOptions = getFromAccountOptions(state.reply)
    if (fromOptions.length === 0) {
        return (<p>Only the recipient of this email can reply</p>)
    }

    if (!config.from) {
        config.from = fromOptions[0].value
    }
    config.megaAttachmentIds = megaAttachmentIds
    // config.documentAttachments = documentIds
    // config.uploadAttachments = uploadIds

    const disabled = state.reply ? {disabled: true} : {}

    const dontShow = config?.mortgage?.requirement?.contactMethod === ContactMethods.DONT && !me.is.advisor

    if (dontShow) {
        return <Alert message="Settings says you're not to contact!" type="error"/>
    }
    return (<div className="d-col gap-12">
        <Form initialValues={config}
              form={form} onFinish={handleFormFinish} className="d-col gap-12">
            <div className="d-row gap-12">
                <Form.Item

                    className="grow mb-0"
                    name="to"
                    label="To">
                    <Select mode="tags" className="grow" placeholder="Email addresses..."/>

                </Form.Item>
                <Button htmlType="submit">
                    {state.sending === false && <>Send <SendOutlined/></>}
                    {state.sending === true && <>Sending <LoadingOutlined/></>}
                </Button>
            </div>
            <div className="d-row gap-12">
                <Form.Item
                    className="grow mb-0"
                    name="cc"
                    label="Cc:">
                    <Select mode="tags" className="grow" placeholder="Email addresses..."
                    />

                </Form.Item>
            </div>
            <div className="d-row gap-12">
                <Form.Item
                    className="grow mb-0"
                    name="bcc"
                    label="Bcc:">
                    <Select {...disabled} mode="tags" className="grow" placeholder="Email addresses..."
                    />

                </Form.Item>
                <Form.Item
                    className="mb-0"
                    style={{width: 150}}
                    name="from"
                    label="From">
                    <Select
                        options={fromOptions}
                    />

                </Form.Item>
            </div>
            <Form.Item
                className="mb-0"
                name="subject"
                label="Subject">
                <Input placeholder="Subject ..."/>
            </Form.Item>
            {!!config.mortgage && (<>
                {/*{!!state.reply && (<div className="d-row gap-9">*/}
                {/*    Attachments not available in reply mode*/}
                {/*    <Button size={"small"} onClick={switchToCompose}>Change to Compose</Button>*/}

                {/*</div>)}*/}
                {/*{!state.reply && (*/}





                {/*<div className="d-row a-center gap-12">*/}
                {/*    <Form.Item*/}
                {/*        className="mb-0 w-100"*/}
                {/*        name="documentAttachments"*/}
                {/*        label="Document Attachments">*/}
                {/*        <TreeSelect*/}
                {/*            multiple={true}*/}
                {/*            treeLine={true}*/}
                {/*            style={{width: '100%',}}*/}
                {/*            treeData={treeDataDocuments}*/}
                {/*            treeIcon={false}*/}
                {/*            treeCheckable={false}*/}
                {/*            value={documentIds}*/}
                {/*            onChange={setDocumentIds}*/}
                {/*        />*/}
                {/*    </Form.Item>*/}
                {/*</div>*/}




                {/*)}*/}
                {/*{!state.reply && (*/}




                {/*<div className="d-row a-center gap-12">*/}
                {/*    <Form.Item*/}
                {/*        className="mb-0 w-100"*/}
                {/*        name="uploadAttachments"*/}
                {/*        label="Upload Attachments">*/}
                {/*        <TreeSelect*/}
                {/*            multiple={true}*/}
                {/*            treeLine={true}*/}
                {/*            style={{width: '100%',}}*/}
                {/*            treeData={treeDataUploads}*/}
                {/*            treeIcon={false}*/}
                {/*            treeCheckable={false}*/}
                {/*            value={documentIds}*/}
                {/*            onChange={setUploadIds}*/}
                {/*        />*/}
                {/*    </Form.Item>*/}
                {/*</div>*/}






                <div className="d-row a-center gap-12">
                    <Form.Item
                        className="mb-0 w-100"
                        name="megaAttachments"
                        label="Attachments">
                        <TreeSelect
                            multiple={true}
                            treeLine={true}
                            style={{width: '100%',}}
                            treeData={megaAttachments}
                            treeIcon={false}
                            treeCheckable={false}
                            value={megaAttachmentIds}
                            onChange={setMegaAttachmentIds}
                        />
                    </Form.Item>
                </div>
                {/*)}*/}
            </>)}

        </Form>
        <div className="p-relative">
            {/*<CKEditor*/}
            {/*    editor={StatementOfSuitabilityParagraphEditor}*/}
            {/*    data={state.body}*/}
            {/*    onReady={editor => {*/}
            {/*        // You can store the "editor" and use when it is needed.*/}

            {/*    }}*/}
            {/*    onChange={(event, editor) => {*/}
            {/*        const data = editor.getData();*/}
            {/*        setBody(data)*/}

            {/*    }}*/}
            {/*    onBlur={(event, editor) => {*/}

            {/*        //liveBody = editor.getData();*/}
            {/*    }}*/}
            {/*    onFocus={(event, editor) => {*/}

            {/*    }}*/}
            {/*/>*/}
            <MyEditor key={key} data={state.body}
                      onReady={editor => {
                          // You can store the "editor" and use when it is needed.

                      }}
                      onChange={(event, editor) => {
                          const data = editor.getData();
                          setBody(data)

                      }}
                      onBlur={(event, editor) => {

                          //liveBody = editor.getData();
                      }}
                      onFocus={(event, editor) => {

                      }}/>
            <div className="p-absolute" style={{top: 4, right: 4}}>
                {/*<EmailImproveButton key={key} body={state.body} setBody={setBody}/>*/}
            </div>
        </div>
    </div>);
}

export default ComposeEmail;